import { CUSTOM, DEFAULT } from '../filterQueryFormat/UsageTypeTypes';
import { FILTER_VALUE_CLEARED, FILTER_VALUE_SET } from '../filterQueryFormat/UsageSubActionTypes';
import { addCondition, getExactKeyPath, removeKeyPath, setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useContext } from 'react';
import { useQuickFiltersOnChangeHandler } from './useQuickFiltersOnChangeHandler';
import { And } from '../filterQueryFormat/logic/FilterLogicGroup';
import FilterUserAction from '../filterQueryFormat/FilterUserAction';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const useOnQuickFilterValueChange = (onUserAction, usageAction, defaultPropertyNames) => {
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily
    },
    quickFiltersInternalValue
  } = useContext(SegmentationFiltersInstanceContext);
  const onQuickFiltersChange = useQuickFiltersOnChangeHandler();
  const version = defaultPropertyNames ? '2' : '1';
  const getType = property => {
    return !defaultPropertyNames || defaultPropertyNames.includes(property) ? DEFAULT : CUSTOM;
  };
  const onClearQuickFilterValue = keyPath => {
    var _getTrackerInstance;
    const conditionToDelete = getExactKeyPath(keyPath, quickFiltersInternalValue);
    onQuickFiltersChange(removeKeyPath(keyPath, quickFiltersInternalValue));
    const property = conditionToDelete.field ? conditionToDelete.field.name : '';
    const type = getType(property);
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('clearedValue', {
      primaryObjectTypeId: baseFilterFamily,
      version,
      property,
      type
    });
    onUserAction(FilterUserAction({
      action: usageAction,
      subAction: FILTER_VALUE_CLEARED,
      filterFamily: baseFilterFamily,
      property,
      type
    }));
  };
  const onSetQuickFilterValue = (newCondition, keyPath) => {
    var _getTrackerInstance2;
    if (keyPath) {
      onQuickFiltersChange(setKeyPath(keyPath, newCondition, quickFiltersInternalValue));
    } else {
      onQuickFiltersChange(addCondition(newCondition, quickFiltersInternalValue || And.of().set('filterFamily', baseFilterFamily)));
    }
    const property = newCondition.field ? newCondition.field.name : '';
    const type = getType(property);
    const eventKey = keyPath ? 'editedValue' : 'addedValue';
    (_getTrackerInstance2 = getTrackerInstance()) === null || _getTrackerInstance2 === void 0 || _getTrackerInstance2.track(eventKey, {
      primaryObjectTypeId: baseFilterFamily,
      version,
      property,
      type
    });
    onUserAction(FilterUserAction({
      action: usageAction,
      subAction: FILTER_VALUE_SET,
      filterFamily: baseFilterFamily,
      property,
      type
    }));
  };
  const onValueChange = keyPath => {
    return newCondition => {
      if (newCondition) {
        onSetQuickFilterValue(newCondition, keyPath);
      } else if (keyPath) {
        onClearQuickFilterValue(keyPath);
      }
    };
  };
  return onValueChange;
};